import { render, staticRenderFns } from "./successSub.vue?vue&type=template&id=4af0baa0&scoped=true&"
import script from "./successSub.js?vue&type=script&lang=js&"
export * from "./successSub.js?vue&type=script&lang=js&"
import style0 from "./successSub.css?vue&type=style&index=0&id=4af0baa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af0baa0",
  null
  
)

export default component.exports